module.exports = __webpack_public_path__ + "fonts/Chivo-Bold.7a272d7.woff2";